export default {
    state: {
        header: false
    },
    mutations: {
        changeHeaderState: (state) => {
            state.header = !state.header
        },
        changeHeaderTrue: (state) => {
            state.header = true
        },
        changeHeaderFalse: (state) => {
            state.header = false
        }
    },
    actions: {
        toggleHeaderState ({commit}) {
            commit('changeHeaderState')
        },
        trueHeaderState ({commit}) {
            commit('changeHeaderTrue')
        },
        falseHeaderState ({commit}) {
            commit('changeHeaderFalse')
        }
    },
    getters: {
        headerState(state) {
            return state.header
        }
    }
}
